import { createSlice } from "@reduxjs/toolkit";
import { searchDishesGroceryAPI } from "../../api/dishes";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const searchDishesGrocerySlice = createSlice({
  name: "searchDishesGrocery",
  initialState: data,
  reducers: {
    searchDishesGrocerySlice(state) {
      state.isLoading = true;
      state.error = ""; // Ensure error is cleared before making a new request
    },
    searchDishesGrocerySliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.error = ""; // Clear any previous errors
    },
    searchDishesGrocerySliceFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    searchDishesGrocerySliceReset(state) {
      state.isLoading = false;
      state.data = null;
      state.error = ""; // Reset error state
    },
  },
});

export const searchDishesGroceryHandler: any = (search: any) => async (dispatch: any) => {
  try {
    dispatch(searchDishesGroceryAction.searchDishesGrocerySlice());
    const response: any = await searchDishesGroceryAPI(search);
    dispatch(searchDishesGroceryAction.searchDishesGrocerySliceSuccess(response?.data));
  } catch (e: any) {
    dispatch(searchDishesGroceryAction.searchDishesGrocerySliceFailure(e?.response?.data));
  }
};

export default searchDishesGrocerySlice.reducer;
export const searchDishesGroceryAction = searchDishesGrocerySlice.actions;
